// Fetches TMDB trending movies (day) on mount; also drives the hero. Stored in Redux.
import { useCallback, useEffect } from "react";
import axios from "axios";
import { API_OPTIONS, buildTmdbUrl } from "../utils/constants";
import { useDispatch } from "react-redux";
import { addTrendingMovies } from "../utils/movieSlice";

const useTrendingMovies = () => {
  const dispatch = useDispatch();
  const TrendingMovies = useCallback(async () => {
    try {
      const response = await axios.get(
        buildTmdbUrl("/trending/movie/day"),
        API_OPTIONS
      );
      dispatch(addTrendingMovies(response.data.results));
    } catch (err) {
      console.error(err);
    }
  }, [dispatch]);

  useEffect(() => {
    TrendingMovies();
  }, [TrendingMovies]);
};

export default useTrendingMovies;
